var _rect, _path, _path2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 4.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75 18C10.1642 18 10.5 18.3358 10.5 18.75V24.375C10.5 24.9963 11.0037 25.5 11.625 25.5H24.375C24.9963 25.5 25.5 24.9963 25.5 24.375V18.75C25.5 18.3358 25.8358 18 26.25 18C26.6642 18 27 18.3358 27 18.75V24.375C27 25.8247 25.8247 27 24.375 27H11.625C10.1753 27 9 25.8247 9 24.375V18.75C9 18.3358 9.33579 18 9.75 18Z",
    fill: "#777777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0942 12.5949C13.8013 12.8878 13.8013 13.3627 14.0942 13.6556C14.3871 13.9485 14.8619 13.9485 15.1548 13.6556L17.0385 11.7719V20.6467C17.0385 21.174 17.466 21.6014 17.9932 21.6014C18.5205 21.6014 18.9479 21.174 18.9479 20.6467V11.7588L20.8447 13.6556C21.1376 13.9485 21.6124 13.9485 21.9053 13.6556C22.1982 13.3627 22.1982 12.8878 21.9053 12.5949L18.5301 9.21967C18.2372 8.92678 17.7623 8.92678 17.4694 9.21967L14.0942 12.5949Z",
    fill: "#777777"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 4.5,
    stroke: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.460fefd798c1fdde0c35de1510673343.svg";
export { ForwardRef as ReactComponent };